export default __webpack_public_path__ + "static/media/invoice_bgi.0ed0f95f.png";